import { render, staticRenderFns } from "./TheSnapshotQueryViewResults.vue?vue&type=template&id=3a47156b&"
import script from "./TheSnapshotQueryViewResults.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotQueryViewResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports